export function clearSession() {
  // Micro Lab admin auth truth is the HttpOnly application session cookie.
}
